











































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'cc-major-btn' })
export default class CCMajorButton extends Vue {
  @Prop({ type: String, required: true })
  readonly name!: string

  @Prop({ type: String, required: false, default: '' })
  readonly icon: string

  @Prop({ type: Boolean, required: false })
  readonly small?: boolean

  @Prop({ type: Boolean, required: false })
  readonly disabled?: boolean

  @Prop({ type: String, required: false, default: '' })
  readonly cols?: string

  @Prop({ type: String, required: false, default: 'primary' })
  readonly color: string
}
